module.exports = __webpack_public_path__ + "img/SKTC_QR.b4d9246b.png";